import {
  Box,
  Fade,
  Modal,
  Grid,
  Button,
  useMediaQuery,
  styled,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import { Close } from "@mui/icons-material";
import CInput from "../CInput";
import theme from "../../config/theme";
import _, { isEmpty, isNull } from "lodash";
import { getNewApiData } from "../../utils/APIHelper";
import { Setting } from "../../utils/Setting";
import { toast } from "react-toastify";
import CAutocomplete from "../CAutocomplete";
import { MATERIAL_UNITS } from "../../config/constants";

const errorObj = {
  nameErr: false,
  nameMsg: "",
  materialTypeErr: false,
  materialTypeMsg: "",
  materialUnitErr: false,
  materialUnitMsg: "",
  materialUnitPriceErr: false,
  materialUnitPriceMsg: "",
  quantityErr: false,
  quantityMsg: "",
  manpowerRateErr: false,
  manpowerRateMsg: "",
  daysErr: false,
  daysMsg: "",
  specificationErr: false,
  specificationMsg: "",
};

const StyledButton = styled(Button)(({ theme }) => ({
  background: "#4D6BF6",
  color: "#ffffff",
  boxShadow: "none",
  border: "1px solid #4D6BF6",
  whiteSpace: "nowrap",
  fontSize: "16px",
  fontWeight: "500",
  borderRadius: "10px",
  padding: ".5vh 1vw",
  letterSpacing: "0",
}));

const GreyStyledButton = styled(Button)(({ theme }) => ({
  background: "#fff",
  color: "#0D0D0E",
  boxShadow: "none",
  border: "1px solid #D7D8D9",
  whiteSpace: "nowrap",
  fontSize: "16px",
  fontWeight: "500",
  borderRadius: "10px",
  padding: ".5vh 1vw",
  letterSpacing: "0",
}));

function BudgetModal({
  isCreationOpen,
  visible,
  handleCloseCreation,
  selectedBudget,
  isEdit,
  proposalId,
  getProjectDetails,
  milestoneId,
  setOuterButtonLoader,
}) {
  const sm = useMediaQuery(theme.breakpoints.down("sm"));
  const md = useMediaQuery(theme.breakpoints.down("md"));

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: sm ? 300 : 550,
    bgcolor: "background.paper",
    borderRadius: 1,
    boxShadow: 24,
    p: "2vh 2vw",
    fontFamily: "Inter Tight",
  };
  const [errObj, setErrObj] = useState(errorObj);
  const [buttonLoader, setButtonLoader] = useState(false);

  const boqTypes = [
    { label: "Materials", value: "Materials" },
    { label: "Activities", value: "Activities" },
  ];

  const [budgetDetails, setBudgetDetails] = useState({
    name: "",
    materialType: "",
    materialUnit: "",
    materialUnitPrice: "",
    quantity: "",
    milestoneId: "",
    specification: "",
    manpowerRate: "",
    days: "",
    boqType: boqTypes[0]?.value,
  });

  const currentTab = budgetDetails?.boqType;

  // A single function to handle both create and update API calls.
  const submitBudgetItem = async (data, isEditFlag) => {
    console.log("Data", data);
    setButtonLoader(true);
    setOuterButtonLoader(true);
    try {
      const method = isEditFlag ? "PUT" : "POST";
      const response = await getNewApiData(
        `${Setting.endpoints.newBudgetItem}`,
        method,
        data,
        { "Content-Type": "application/json" },
        true
      );
      if (response) {
        toast.success(
          isEditFlag
            ? "Budget Item Updated Successfully"
            : "Budget Item Added Successfully"
        );
        getProjectDetails(proposalId);
      }
    } catch (error) {
      toast.error(error.toString());
    } finally {
      setButtonLoader(false);
      setOuterButtonLoader(false);
    }
  };

  // Optimized validate function
  const validate = () => {
    let error = {};
    let valid = true;

    if (isEmpty(budgetDetails.name?.trim())) {
      valid = false;
      error.nameErr = true;
      error.nameMsg = "Please enter the name";
    } else if (budgetDetails?.name?.length > 50) {
      valid = false;
      error.nameErr = true;
      error.nameMsg = "Please enter the name less then 50 characters";
    }

    const positiveIntRegex = /^[1-9]\d*$/;
    const positiveFloatRegex = /^[0-9]*\.?[0-9]{0,2}$/;
    const regex = /^\d+(\.\d+)?$/;

    if (
      isEmpty(budgetDetails?.materialType?.trim()) &&
      (isEmpty(budgetDetails?.materialUnit) ||
        isNull(budgetDetails?.materialUnit)) &&
      isEmpty(budgetDetails.materialUnitPrice?.toString()) &&
      isEmpty(budgetDetails?.quantity?.toString()) &&
      isEmpty(budgetDetails?.manpowerRate?.toString()) &&
      isEmpty(budgetDetails?.days?.toString())
    ) {
      if (isEmpty(budgetDetails.materialType?.trim())) {
        valid = false;
        error.materialTypeErr = true;
        error.materialTypeMsg = "Please enter the material type";
      }

      if (isEmpty(budgetDetails.materialUnitPrice?.toString())) {
        valid = false;
        error.materialUnitPriceErr = true;
        error.materialUnitPriceMsg = "Please enter the material unit price";
      } else if (
        !positiveFloatRegex.test(budgetDetails.materialUnitPrice) ||
        parseFloat(budgetDetails.material_unit_price) <= 0
      ) {
        valid = false;
        error.materialUnitPriceErr = true;
        error.materialUnitPriceMsg = "Please enter valid material unit price";
      }
      if (isEmpty(budgetDetails?.quantity?.toString())) {
        valid = false;
        error.quantityErr = true;
        error.quantityMsg = "Please enter the material qty";
      } else if (parseFloat(budgetDetails?.quantity) <= 0) {
        valid = false;
        error.quantityErr = true;
        error.quantityMsg = "Quantity cannot be 0 or 0.00";
      } else if (!positiveFloatRegex.test(budgetDetails?.quantity)) {
        valid = false;
        error.quantityErr = true;
        error.quantityMsg = "Please enter valid material qty";
      } else if (parseFloat(budgetDetails?.quantity) >= 100000) {
        valid = false;
        error.quantityErr = true;
        error.quantityMsg = "Please enter Quantity less than 100000";
      }

      if (
        isEmpty(budgetDetails.materialUnit) ||
        isNull(budgetDetails?.materialUnit)
      ) {
        valid = false;
        error.materialUnitErr = true;
        error.materialUnitMsg = "Please enter material unit";
      }

      if (isEmpty(budgetDetails?.manpowerRate?.toString())) {
        valid = false;
        error.manpowerRateErr = true;
        error.manpowerRateMsg = "Please enter the manpower rate";
      } else if (!regex.test(budgetDetails?.manpowerRate)) {
        valid = false;
        error.manpowerRateErr = true;
        error.manpowerRateMsg = "Please enter valid manpower rate";
      } else if (budgetDetails?.manpowerRate >= 100000) {
        valid = false;
        error.manpowerRateErr = true;
        error.manpowerRateMsg = "Please enter valid manpower rate under 10000 ";
      }

      if (isEmpty(budgetDetails?.days?.toString())) {
        valid = false;
        error.daysErr = true;
        error.daysMsg = "Please enter the days";
      } else if (!positiveIntRegex.test(budgetDetails?.days)) {
        valid = false;
        error.daysErr = true;
        error.daysErr = "Please enter valid days";
      } else if (budgetDetails?.days >= 365) {
        valid = false;
        error.daysErr = true;
        error.daysMsg = "Please enter days under 365";
      }
    } else {
      if (
        !isEmpty(budgetDetails.materialType?.trim()) ||
        !isEmpty(budgetDetails.materialUnitPrice?.toString()) ||
        (!isEmpty(budgetDetails.materialUnit) &&
          !isNull(budgetDetails?.materialUnit)) ||
        !isEmpty(budgetDetails?.quantity?.toString())
      ) {
        if (isEmpty(budgetDetails.materialType?.trim())) {
          valid = false;
          error.materialTypeErr = true;
          error.materialTypeMsg = "Please enter the material type";
        }
        if (!budgetDetails.materialUnitPrice) {
          valid = false;
          error.materialUnitPriceErr = true;
          error.materialUnitPriceMsg = "Please enter the material unit price";
        } else if (
          !positiveFloatRegex.test(budgetDetails.materialUnitPrice) ||
          parseFloat(budgetDetails.materialUnitPrice) <= 0
        ) {
          valid = false;
          error.materialUnitPriceErr = true;
          error.materialUnitPriceMsg = "Please enter valid material unit price";
        }

        if (isEmpty(budgetDetails?.quantity?.toString())) {
          valid = false;
          error.quantityErr = true;
          error.quantityMsg = "Please enter the material qty";
        } else if (parseFloat(budgetDetails?.quantity) <= 0) {
          valid = false;
          error.quantityErr = true;
          error.quantityMsg = "Quantity cannot be 0 or 0.00";
        } else if (!positiveFloatRegex.test(budgetDetails?.quantity)) {
          valid = false;
          error.quantityErr = true;
          error.quantityMsg = "Please enter a valid material qty";
        } else if (parseFloat(budgetDetails?.quantity) >= 100000) {
          valid = false;
          error.quantityErr = true;
          error.quantityMsg = "Please enter Quantity less than 100000";
        }

        if (isEmpty(budgetDetails.materialUnit)) {
          valid = false;
          error.materialUnitErr = true;
          error.materialUnitMsg = "Please enter material unit";
        }
      }
      if (
        !isEmpty(budgetDetails?.manpowerRate?.toString()) ||
        !isEmpty(budgetDetails?.days?.toString())
      ) {
        if (isEmpty(budgetDetails?.manpowerRate?.toString())) {
          valid = false;
          error.manpowerRateErr = true;
          error.manpowerRateMsg = "Please enter the manpower rate";
        } else if (!regex.test(budgetDetails.manpowerRate)) {
          valid = false;
          error.manpowerRateErr = true;
          error.manpowerRateMsg = "Please enter valid manpower rate";
        } else if (budgetDetails?.manpowerRate >= 100000) {
          valid = false;
          error.manpowerRateErr = true;
          error.manpowerRateMsg =
            "Please enter valid manpower rate under 10000 ";
        }

        if (
          isEmpty(budgetDetails?.days?.toString()) ||
          budgetDetails?.days <= 0
        ) {
          valid = false;
          error.daysErr = true;
          error.daysMsg = "Please enter the days";
        } else if (!positiveIntRegex.test(budgetDetails?.days)) {
          valid = false;
          error.daysErr = true;
          error.daysMsg = "Please enter valid days";
        }
      }
    }
    setErrObj(error);
    if (!valid) return;

    handleCloseCreation();

    let body = {
      name: budgetDetails?.name,
      milestoneId: parseInt(milestoneId),
      materialType: budgetDetails?.materialType,
      materialUnit: budgetDetails?.materialUnit,
      materialUnitPrice: budgetDetails?.materialUnitPrice,
      quantity: budgetDetails?.quantity,
      manpowerRate: isNaN(parseInt(budgetDetails?.manpowerRate))
        ? null
        : parseInt(budgetDetails?.manpowerRate),
      days: isNaN(parseInt(budgetDetails?.days))
        ? null
        : parseInt(budgetDetails?.days),
      specification: budgetDetails?.specification,
      boqType: budgetDetails?.boqType,
    };

    if (isEdit) {
      body = { ...body, proposalBudgetId: parseInt(selectedBudget?.id) };

      let numericFilteredBody = Object.fromEntries(
        Object.entries(body).filter(
          ([key, value]) => !(typeof value === "number" && isNaN(value))
        )
      );

      let finalFilteredBody = Object.fromEntries(
        Object.entries(numericFilteredBody).filter(
          ([key, value]) => !(typeof value === "string" && value.trim() === "")
        )
      );

      submitBudgetItem(finalFilteredBody, isEdit);
    } else {
      submitBudgetItem(body, isEdit);
    }
  };

  useEffect(() => {
    if (selectedBudget) {
      console.log("selectedM", selectedBudget);
      setBudgetDetails({
        name: selectedBudget?.name || "",
        materialType: selectedBudget?.material_type || "",
        materialUnit: selectedBudget?.material_unit || "",
        materialUnitPrice: selectedBudget?.material_unit_price || "",
        quantity: selectedBudget?.qty || "",
        milestoneId: milestoneId,
        specification: selectedBudget?.specification || "",
        manpowerRate: selectedBudget?.manpower_rate || "",
        days: selectedBudget?.days || "",
        boqType: selectedBudget?.boq_type || boqTypes[0]?.value,
      });
    }
  }, [selectedBudget]);

  return (
    <>
      <Modal open={isCreationOpen || visible} onClose={handleCloseCreation}>
        <Fade in={isCreationOpen || visible}>
          <Box sx={style}>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div className="addMilestoneHeader">
                {isEdit ? "Update" : "Add"} Budget Item
              </div>
              <Close
                style={{ cursor: "pointer" }}
                onClick={() => handleCloseCreation()}
              />
            </div>
            <Grid container>
              <Grid item xs={12} mt={2}>
                <CAutocomplete
                  label="BOQ Type"
                  placeholder="Select BOQ type"
                  value={boqTypes.find((type) => type.value === currentTab)}
                  onChange={(e, newValue) => {
                    console.log(",", newValue);
                    setBudgetDetails({
                      ...budgetDetails,
                      boqType: newValue?.value,
                    });
                  }}
                  options={boqTypes.map((type) => ({
                    value: type.value,
                    label: type.label,
                  }))}
                  getOptionLabel={(option) => option?.value}
                  disableClearable
                />
              </Grid>

              <Grid item xs={12} id="name" mt={2}>
                <CInput
                  label={<span>Budget Item Name</span>}
                  placeholder="Enter Budget Name..."
                  value={budgetDetails.name}
                  onChange={(e) => {
                    setBudgetDetails({
                      ...budgetDetails,
                      name: e.target.value,
                    });
                    setErrObj({
                      ...errObj,
                      nameErr: false,
                      nameMsg: "",
                    });
                  }}
                  inputProps={{ maxLength: 50 }}
                  error={errObj.nameErr}
                  helpertext={errObj.nameMsg}
                />
              </Grid>

              <Grid item xs={12} id="materialType" mt={2}>
                <CInput
                  label={<span>Material Type</span>}
                  placeholder="marble, wood, etc..."
                  value={budgetDetails.materialType}
                  onChange={(e) => {
                    setBudgetDetails({
                      ...budgetDetails,
                      materialType: e.target.value,
                    });
                    setErrObj({
                      ...errObj,
                      materialTypeErr: false,
                      materialTypeMsg: "",
                    });
                  }}
                  error={errObj.materialTypeErr}
                  helpertext={errObj.materialTypeMsg}
                />
              </Grid>

              <Grid
                item
                container
                columnGap={1}
                wrap={md ? "wrap" : "nowrap"}
                mt={2}
              >
                <Grid item xs={12} md={4} id="Unit">
                  <CAutocomplete
                    label="Material Unit"
                    placeholder="Enter material unit"
                    value={budgetDetails.materialUnit}
                    onChange={(e, newValue) => {
                      setBudgetDetails({
                        ...budgetDetails,
                        materialUnit: newValue,
                      });
                      setErrObj({
                        ...errObj,
                        materialUnitErr: false,
                        materialUnitMsg: "",
                      });
                    }}
                    options={MATERIAL_UNITS}
                    getOptionLabel={(option) => option}
                    error={errObj.materialUnitErr}
                    helpertext={errObj.materialUnitMsg}
                  />
                </Grid>
                <Grid item xs={12} md={4} id="price">
                  <CInput
                    label="Material Unit Price"
                    placeholder="Enter amount...."
                    value={budgetDetails.materialUnitPrice}
                    type="tel"
                    onChange={(e) => {
                      const regex = /^\d*\.?\d{0,2}$/;
                      if (regex.test(e.target.value)) {
                        setBudgetDetails({
                          ...budgetDetails,
                          materialUnitPrice: e.target.value,
                        });
                      }
                      setErrObj({
                        ...errObj,
                        materialUnitPriceErr: false,
                        materialUnitPriceMsg: "",
                      });
                    }}
                    inputProps={{
                      pattern: "[0-9]*",
                      inputMode: "decimal",
                    }}
                    error={errObj.materialUnitPriceErr}
                    helpertext={errObj.materialUnitPriceMsg}
                  />
                </Grid>
                <Grid item xs={12} md={4} id="qty">
                  <CInput
                    label="Quantity"
                    placeholder="N/A"
                    value={budgetDetails.quantity}
                    type="tel"
                    onChange={(e) => {
                      const regex = /^\d*\.?\d{0,2}$/;
                      if (regex.test(e.target.value)) {
                        setBudgetDetails({
                          ...budgetDetails,
                          quantity: e.target.value,
                        });
                      }
                      setErrObj({
                        ...errObj,
                        quantityErr: false,
                        quantityMsg: "",
                      });
                    }}
                    inputProps={{
                      pattern: "[0-9]*",
                      inputMode: "decimal",
                    }}
                    error={errObj.quantityErr}
                    helpertext={errObj.quantityMsg}
                  />
                </Grid>
              </Grid>

              <Grid
                item
                container
                columnGap={1}
                wrap={md ? "wrap" : "nowrap"}
                mt={2}
              >
                <Grid item xs={12} md={6} mb={2}>
                  <CInput
                    label="Manpower Rate"
                    placeholder="Enter amount...."
                    value={budgetDetails.manpowerRate}
                    type="number"
                    onChange={(e) => {
                      const bool = /^[0-9]+(?:\.[0-9]+)?$/.test(
                        Number(e.target.value)
                      );
                      if (bool) {
                        setBudgetDetails({
                          ...budgetDetails,
                          manpowerRate: e.target.value,
                        });
                      }
                      setErrObj({
                        ...errObj,
                        manpowerRateErr: false,
                        manpowerRateMsg: "",
                      });
                    }}
                    error={errObj.manpowerRateErr}
                    helpertext={errObj.manpowerRateMsg}
                  />
                </Grid>
                <Grid item xs={12} md={6} mb={2}>
                  <CInput
                    label="Days"
                    placeholder="N/A"
                    value={budgetDetails.days}
                    type="tel"
                    onChange={(e) => {
                      const bool = /^[0-9]+$/.test(Number(e.target.value));
                      if (bool) {
                        setBudgetDetails({
                          ...budgetDetails,
                          days: e.target.value,
                        });
                      }
                      setErrObj({
                        ...errObj,
                        daysErr: false,
                        daysMsg: "",
                      });
                    }}
                    inputProps={{
                      pattern: "[0-9]*",
                      inputMode: "numeric",
                    }}
                    error={errObj.daysErr}
                    helpertext={errObj.daysMsg}
                  />
                </Grid>
              </Grid>

              <Grid item xs={12} id="specification" mt={0} mb={1}>
                <CInput
                  multiline
                  rows={3}
                  label="Specification"
                  placeholder="Write specifiction about budget item here..."
                  value={budgetDetails.specification}
                  onChange={(e) => {
                    setBudgetDetails({
                      ...budgetDetails,
                      specification: e.target.value,
                    });
                    setErrObj({
                      ...errObj,
                      specificationErr: false,
                      specificationMsg: "",
                    });
                  }}
                  error={errObj.specificationErr}
                  helpertext={errObj.specificationMsg}
                />
              </Grid>
            </Grid>

            <Grid
              item
              container
              justifyContent="center"
              gap={sm ? 1 : 2}
              wrap="nowrap"
              marginTop="10px"
            >
              <Grid
                item
                xs={6}
                sx={{ display: "flex", justifyContent: "flex-start" }}
              >
                <GreyStyledButton onClick={handleCloseCreation}>
                  Cancel
                </GreyStyledButton>
              </Grid>
              <Grid
                item
                xs={6}
                sx={{ display: "flex", justifyContent: "flex-end" }}
              >
                <StyledButton
                  variant="contained"
                  onClick={validate}
                  disabled={buttonLoader}
                >
                  {isEdit ? "Update" : "Add"} Budget Item
                </StyledButton>
              </Grid>
            </Grid>
          </Box>
        </Fade>
      </Modal>
    </>
  );
}

export default BudgetModal;
